import React from "react";
import "../styles/ErrorAutoLogoutStyle.css";
import infoImg from "../assets/images/infoImg.png";
import closeIcon from "../assets/images/crossCloseicon.png";

interface AutoLogoutPopupProps {
  btn1Pressed: () => void;
  btn2Pressed: () => void;
  body: string;
}

const AutoLogoutAlertPopup: React.FC<AutoLogoutPopupProps> = ({
  body,
  btn1Pressed,
  btn2Pressed,
}) => {
  return (
    <div className="Error-alertpopup-overlay">
      <div
        className="Error-alertpopup-container"
        style={{
          position: "relative",
          borderRadius: "12px",
          overflow: "hidden",
          background: "#fff",
          width: "420px",
          height: "auto",
        }}
      >
        {/* Header */}
        <div
          style={{
            backgroundColor: "#A78903",
            height: "60px",
            position: "relative",
          }}
        >
          {/* Top Icon */}
          <img
            src={infoImg}
            alt="info"
            style={{
              position: "absolute",
              top: "25px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "75px",
              height: "75px",
              objectFit: "contain",
              zIndex: 10,
            }}
          />

          {/* Close Button */}
          <img
            src={closeIcon}
            alt="close"
            onClick={btn2Pressed}
            style={{
              position: "absolute",
              right: "15px",
              top: "15px",
              width: "20px",
              height: "20px",
              cursor: "pointer",
            }}
          />
        </div>

        {/* Title */}
        <div
          style={{
            marginTop: "50px",
            textAlign: "center",
            color: "#4b4c4e",
            fontFamily: "Mazzard",
            fontSize: "24px",
            fontWeight: 600,
          }}
        >
          Info
        </div>

        {/* Body */}
        <div
          style={{
            padding: "20px",
            textAlign: "center",
            fontFamily: "Mazzard",
          }}
        >
          <span
            style={{
              fontSize: "16px",
              color: "#353535",
              // lineHeight: "24px",
            }}
          >
            {body}
          </span>
        </div>

        {/* Footer */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            padding: "0 0 24px",
          }}
        >
          <button
            onClick={btn1Pressed}
            style={{
              backgroundColor: "transparent",
              border: "2px solid #A78903",
              color: "#000",
              width: "100px",
              height: "40px",
              borderRadius: "6px",
              fontFamily: "Mazzard",
              cursor: "pointer",
            }}
          >
            OK
          </button>

          <button
            onClick={btn2Pressed}
            style={{
              backgroundColor: "transparent",
              border: "2px solid #A78903",
              color: "#000",
              width: "100px",
              height: "40px",
              borderRadius: "6px",
              fontFamily: "Mazzard",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AutoLogoutAlertPopup;
